export default "__VITE_ASSET__BuGu7hli__"